import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafePipe } from './safe.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ContentViewsComponent } from './content-views.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
  ],
  exports: [
    ContentViewsComponent
      ],
  declarations: [ContentViewsComponent, SafePipe],
  providers: []
})
export class ContentViewsModule { }
